import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class SaveCommand extends Component {
  state = { canShowForm: false };
  
  render() {
    
    return (
        <svg className= {this.props.actif ? "actif": "disable"} height={this.props.height? this.props.height :"18"} viewBox="0 0 512.007 512.007" onClick={this.props.onClick}>
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
            <path d="M377 5110 c-177 -30 -337 -194 -367 -376 -13 -80 -13 -4268 0 -4348
              30 -187 189 -346 376 -376 80 -13 4268 -13 4348 0 187 30 346 189 376 376 6
              36 10 760 10 1882 0 1603 -2 1828 -15 1856 -20 42 -952 972 -988 985 -34 13
              -3665 13 -3740 1z m553 -927 c0 -412 4 -733 10 -768 20 -123 112 -260 216
              -321 22 -13 67 -33 99 -44 57 -20 83 -20 1185 -20 1248 0 1176 -4 1291 66 93
              56 159 138 201 250 22 59 22 65 26 802 l3 742 32 0 c29 0 75 -43 465 -433
              l432 -432 -2 -1810 c-3 -1744 -4 -1811 -22 -1845 -26 -49 -64 -88 -111 -113
              -34 -18 -62 -22 -187 -25 l-148 -4 0 1121 c0 1238 4 1163 -64 1195 -31 15
              -186 16 -1796 16 -1610 0 -1765 -1 -1796 -16 -68 -32 -64 43 -64 -1195 l0
              -1121 -147 4 c-118 3 -155 8 -183 22 -49 25 -88 64 -113 111 l-22 40 0 2155
              c0 2083 1 2156 19 2190 36 69 92 114 161 131 17 4 139 7 273 8 l242 1 0 -707z
              m2790 -20 c0 -683 -2 -730 -19 -768 -23 -51 -89 -111 -138 -124 -26 -7 -390
              -11 -1128 -11 -1034 0 -1092 1 -1130 19 -50 22 -96 67 -121 118 -18 36 -19 74
              -22 752 -1 393 0 721 2 728 4 11 233 13 1281 13 l1275 0 0 -727z m470 -2883
              l0 -1050 -1630 0 -1630 0 0 1050 0 1050 1630 0 1630 0 0 -1050z"/>
            <path d="M2832 4621 c-16 -17 -32 -44 -36 -62 -3 -17 -6 -239 -5 -493 0 -497
              2 -513 52 -550 27 -20 43 -21 288 -24 291 -3 314 1 343 63 23 48 24 990 1
              1035 -31 60 -33 60 -336 60 l-277 0 -30 -29z m428 -551 l0 -350 -115 0 -115 0
              0 350 0 350 115 0 115 0 0 -350z"/>
          </g>
        </svg>
    );

    /*<svg className= {this.props.actif ? "actif": "disable"} height={this.props.height? this.props.height :"18"} viewBox="0 0 512.007 512.007" onClick={this.props.onClick}>
          <g>
            <path d="m511.927 126.537c-.279-2.828-1.38-5.666-3.315-8.027-.747-.913 6.893 6.786-114.006-114.113-2.882-2.882-6.794-4.395-10.612-4.394-9.096 0-329.933 0-338.995 0-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45 .001-364.186.041-339.316-.072-340.466zm-166.927-96.534v98c0 8.271-6.729 15-15 15h-19v-113zm-64 0v113h-139c-8.271 0-15-6.729-15-15v-98zm64 291h-218v-19c0-8.271 6.729-15 15-15h188c8.271 0 15 6.729 15 15zm-218 161v-131h218v131zm355-15c0 8.271-6.729 15-15 15h-92c0-19.555 0-157.708 0-180 0-24.813-20.187-45-45-45h-188c-24.813 0-45 20.187-45 45v180h-52c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h52v98c0 24.813 20.187 45 45 45h188c24.813 0 45-20.187 45-45v-98h2.787l104.213 104.214z"/>
          </g>
        </svg>
        */
  }
}

export default SaveCommand;
